// True inside the prerender service's headless Chrome. Client-side redirects
// must NOT run there: the snapshot has to keep the 301/404 meta the SPA set,
// and a navigate() would replace it with a 200 copy of the target page cached
// under the wrong URL for a week.
//
// navigator.webdriver is what Puppeteer sets today (--enable-automation) and
// was the only signal this relied on. It is a Chrome default that could change
// silently, so the renderer now also stamps an explicit flag
// (scripts/prerender/server.js, evaluateOnNewDocument); either is enough.
export const isPrerender = (): boolean =>
  !!window.navigator.webdriver ||
  (window as unknown as { __PRERENDER__?: boolean }).__PRERENDER__ === true;
